import { useState } from "react";
import type { FormEvent } from "react";
import { login } from "../../useCases/auth";
import "./Login.scss";
import type { Auth } from "firebase/auth";
import type { Firestore } from "firebase/firestore";

interface LoginProps {
	auth: Auth;
	db: Firestore;
}

export const Login = (props: LoginProps) => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");

	const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		try {
			const form = e.currentTarget;
			const formData = new FormData(form);
			const email = formData.get("username") as string;
			const password = formData.get("password") as string;
			await login(props.auth, { email, password });
		} catch (_err) {
			setError("Invalid credentials");
		}
	};

	return (
		<div className="login">
			<div className="background">
				<div className="bubble" />
			</div>
			<div className="header">
				<img width={205} src={"/logo.png"} alt="Logo" />
			</div>
			<div className="body">
				<div className="form">
					<form className="form-body" onSubmit={handleSubmit}>
						<h1>Inicio de sesión</h1>
						{error && <div className="error-message">{error}</div>}
						<div className="form-group">
							<label htmlFor="username">Usuario</label>
							<input
								type="text"
								id="username"
								name="username"
								value={username}
								onChange={(e) => setUsername(e.target.value)}
								autoComplete="email"
								required
							/>
						</div>
						<div className="form-group">
							<label htmlFor="password">Contraseña</label>
							<input
								type="password"
								id="password"
								name="password"
								autoComplete="current-password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								required
							/>
						</div>
						<button type="submit">Iniciar Sesión</button>
					</form>
				</div>
				<div className="login-image">
					<img width={500} src={"/login-image.png"} alt="Logo" />
				</div>
			</div>
		</div>
	);
};
